// extracted by mini-css-extract-plugin
module.exports = {"swatch":"extraStyles_swatch__chi0u","swatchDefault":"extraStyles_swatchDefault__lF9yr","swatchSmall":"extraStyles_swatchSmall__jmlyN"};